var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('Cell',{key:index,staticClass:"mb-5",attrs:{"ticket":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }